import { Button, Card, StatusInfo } from '@george-labs.com/design-system';
import type { FC } from 'react';

import { t } from '@luna/i18n';

interface Props {
    refetch: () => void;
}

export const BankMessageDetailsError: FC<Props> = ({ refetch }) => (
    <Card>
        <StatusInfo
            preferIllustration
            data-cy="bank-message-error"
            variant={StatusInfo.VARIANT.ERROR}
            title={t('bankMessages.details.bankMessageErrorTitle')}
            buttons={[
                <Button key="refetch" data-cy="reload-bank-message-details" onClick={refetch}>
                    {t('bankMessages.details.tryAgainButton')}
                </Button>,
            ]}
        >
            {t('bankMessages.details.bankMessageErrorText')}
        </StatusInfo>
    </Card>
);
